import { Box, Typography } from '@mui/material'

import { HowTo } from '@ecm/data/ArticleHowTo'
import Color from '@ecm/ui/element/Color'
import ContentfulImage, { ImageType } from '@ecm/ui/element/ContentfulImage'

type ArticleHowToProps = {
  howTo: HowTo
}
const ArticleHowTo = ({ howTo }: ArticleHowToProps) => (
  <Box pt="3em">
    <Typography variant="h5" component="h2" color={Color.slate.normal}>
      {howTo.stepsHeader}
    </Typography>
    {howTo.steps &&
      howTo.steps.map((step, i) => (
        <Box py="1em" id={`step${i + 1}`} key={i}>
          <Typography variant="p2" component="h3" color={Color.slate.normal} margin="0">
            {step.title}
          </Typography>
          <Typography variant="p2" color={Color.slate.normal}>
            {step.text}
          </Typography>
          {step.image && (
            <ContentfulImage
              imageType={ImageType.BlogResponsive}
              src={step.image}
              alt={step.title}
              width={724}
              height={483}
              layout="responsive"
              objectFit="cover"
            />
          )}
        </Box>
      ))}

    {howTo.cost && (
      <Typography variant="p2" color={Color.slate.normal}>
        <b>Cost: </b> {howTo.cost}
      </Typography>
    )}
    {howTo.time && (
      <Typography variant="p2" color={Color.slate.normal}>
        <b>Time: </b>
        {howTo.time}
      </Typography>
    )}
    {(howTo.supply || howTo.tool) && (
      <Typography variant="p2" color={Color.slate.normal}>
        <b>Necessary Items:</b> {howTo.supply}
        {howTo.supply && howTo.tool ? ', ' : ''}
        {howTo.tool}
      </Typography>
    )}
  </Box>
)
export default ArticleHowTo
